














import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      titlePageChild: "SSH Server",
      subtitlePageChild: "SSH Server list",
    };
  },
});
